Controller.$inject = ['$element', '$scope'];

function Controller() {
}

export function HuiDialogBody() {
    return {
        restrict: 'E',
        scope: true,
        replace: true,
        bindToController: {},
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: () => {
            return `<div class="hui-dialog-body d-flex" ng-transclude></div>
            `;
        }
    };
} 